import { Component, input } from '@angular/core';

@Component({
  selector: 'aux-file-manager-error-message',
  template: `
    @if (errorMessage()) {
      <div
        class="my-4 overflow-x-hidden text-ellipsis rounded-md bg-aux-error p-5 font-medium text-white"
      >
        {{ errorMessage() }}
      </div>
    }
  `,
})
export class FileManagerErrorMessageComponent {
  errorMessage = input<string>('');
}
